import { connect } from 'react-redux';
import TvComponent from '../TvComponent';

const mapStateToProps = () => ({
});
const TvComponentContainer = connect(
    mapStateToProps, {},
)(TvComponent);

export default (TvComponentContainer);
